// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print-style layout for user safety forms (orientation through FLHA). */
.user-print-form {
  background: #ffffff;
  color: #111827;
  font-size: 1rem;
  line-height: 1.5;
}

.user-print-form h2,
.user-print-form h3,
.user-print-form h4 {
  color: #111827 !important;
}

.user-print-form h3 {
  font-size: 1.25rem !important;
}

.user-print-form h4 {
  font-size: 1.0625rem !important;
}

.user-print-form p,
.user-print-form span,
.user-print-form li,
.user-print-form label {
  color: #1f2937 !important;
}

.user-print-form .text-xs {
  font-size: 0.875rem !important;
}

.user-print-form .text-sm {
  font-size: 1rem !important;
}

.user-print-form .text-lg {
  font-size: 1.3125rem !important;
}

.user-print-form input,
.user-print-form textarea,
.user-print-form select {
  background: #ffffff !important;
  color: #111827 !important;
  border-color: #9ca3af !important;
  font-size: 1rem !important;
}

.user-print-form th,
.user-print-form td {
  font-size: 0.9375rem !important;
}

.user-print-form input::placeholder,
.user-print-form textarea::placeholder {
  color: #6b7280 !important;
}

.user-print-form table {
  border-color: #d1d5db !important;
}

.user-print-form thead,
.user-print-form th {
  background: #f3f4f6 !important;
  color: #111827 !important;
}

.user-print-form td {
  color: #111827 !important;
  border-color: #e5e7eb !important;
}

.user-print-form tr {
  background: #ffffff !important;
}

.user-print-form tbody tr:nth-child(even) {
  background: #f9fafb !important;
}

.user-print-form .border-gray-800,
.user-print-form .border-gray-700,
.user-print-form .border-gray-600 {
  border-color: #d1d5db !important;
}

.user-print-form .bg-black,
.user-print-form .bg-gray-950,
.user-print-form .bg-gray-950\\/70,
.user-print-form .bg-gray-900\\/80,
.user-print-form .bg-gray-900\\/60,
.user-print-form .bg-gray-900\\/30 {
  background: #ffffff !important;
}

.user-print-form .bg-gray-900,
.user-print-form thead.bg-gray-900 {
  background: #f3f4f6 !important;
}

.user-print-form .text-white {
  color: #111827 !important;
}

.user-print-form .text-gray-200,
.user-print-form .text-gray-300,
.user-print-form .text-gray-400 {
  color: #374151 !important;
}

.user-print-form .text-amber-200,
.user-print-form .text-amber-200\\/90 {
  color: #374151 !important;
}

.user-print-form button.bg-amber-200,
.user-print-form button[class*='bg-[#eda448]'],
.user-print-form button[style*='background-color'] {
  background: #2563eb !important;
  color: #ffffff !important;
  border: 1px solid #1d4ed8 !important;
  font-size: 1rem !important;
}

.user-print-form button.bg-amber-200:hover,
.user-print-form button[class*='bg-[#eda448]']:hover {
  background: #1d4ed8 !important;
}

.user-print-form input[type='radio'],
.user-print-form input[type='checkbox'] {
  accent-color: #111827;
}

/* Hide numbered prefixes only inside form content while generating PDF export */
.user-print-form.pdf-export-active {
  padding: 1.5rem !important;
  margin: 0 !important;
  overflow: visible !important;
  max-width: none !important;
  box-sizing: border-box !important;
  background: #ffffff !important;
}

.user-print-form.pdf-export-active .pdf-export-form-title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #111827 !important;
  margin: 0 0 1rem 0 !important;
  line-height: 1.3 !important;
}

.user-print-form.pdf-export-active .form-heading-number,
.user-print-form.pdf-export-active .form-item-number {
  display: none !important;
}

.user-print-form.pdf-export-active table {
  width: 100% !important;
  table-layout: fixed !important;
  border-collapse: collapse !important;
}

.user-print-form.pdf-export-active tr {
  break-inside: avoid !important;
  page-break-inside: avoid !important;
}

.user-print-form.pdf-export-active thead {
  display: table-header-group !important;
}

.user-print-form.pdf-export-active label {
  margin-bottom: 0.625rem !important;
  display: block !important;
}

.user-print-form.pdf-export-active .flex.flex-col {
  gap: 0.25rem !important;
}

.user-print-form.pdf-export-active input,
.user-print-form.pdf-export-active textarea,
.user-print-form.pdf-export-active select {
  max-width: 100% !important;
  line-height: 1.5 !important;
  min-height: 2.25rem !important;
}

.user-print-form.pdf-export-active input::placeholder,
.user-print-form.pdf-export-active textarea::placeholder {
  color: #d1d5db !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #d1d5db !important;
}

.user-print-form.pdf-export-active input:placeholder-shown,
.user-print-form.pdf-export-active textarea:placeholder-shown {
  color: #d1d5db !important;
  -webkit-text-fill-color: #d1d5db !important;
}

.user-print-form.pdf-export-blank input::placeholder,
.user-print-form.pdf-export-blank textarea::placeholder {
  color: #d1d5db !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #d1d5db !important;
}

/* Sidebar navigation numbers always stay visible (never part of PDF export) */
aside .sidebar-form-number {
  display: inline !important;
}

/* Handwritten signature pad in print-style forms */
.user-print-form .signature-field-tabs .inline-flex {
  border-color: #9ca3af !important;
}

.user-print-form .signature-field-tabs button {
  background: #ffffff !important;
  color: #374151 !important;
}

.user-print-form .signature-field-tabs canvas {
  background: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/userPrintForms.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,gFAAgF;AAChF;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,8EAA8E;AAC9E;EACE,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Print-style layout for user safety forms (orientation through FLHA). */\n.user-print-form {\n  background: #ffffff;\n  color: #111827;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.user-print-form h2,\n.user-print-form h3,\n.user-print-form h4 {\n  color: #111827 !important;\n}\n\n.user-print-form h3 {\n  font-size: 1.25rem !important;\n}\n\n.user-print-form h4 {\n  font-size: 1.0625rem !important;\n}\n\n.user-print-form p,\n.user-print-form span,\n.user-print-form li,\n.user-print-form label {\n  color: #1f2937 !important;\n}\n\n.user-print-form .text-xs {\n  font-size: 0.875rem !important;\n}\n\n.user-print-form .text-sm {\n  font-size: 1rem !important;\n}\n\n.user-print-form .text-lg {\n  font-size: 1.3125rem !important;\n}\n\n.user-print-form input,\n.user-print-form textarea,\n.user-print-form select {\n  background: #ffffff !important;\n  color: #111827 !important;\n  border-color: #9ca3af !important;\n  font-size: 1rem !important;\n}\n\n.user-print-form th,\n.user-print-form td {\n  font-size: 0.9375rem !important;\n}\n\n.user-print-form input::placeholder,\n.user-print-form textarea::placeholder {\n  color: #6b7280 !important;\n}\n\n.user-print-form table {\n  border-color: #d1d5db !important;\n}\n\n.user-print-form thead,\n.user-print-form th {\n  background: #f3f4f6 !important;\n  color: #111827 !important;\n}\n\n.user-print-form td {\n  color: #111827 !important;\n  border-color: #e5e7eb !important;\n}\n\n.user-print-form tr {\n  background: #ffffff !important;\n}\n\n.user-print-form tbody tr:nth-child(even) {\n  background: #f9fafb !important;\n}\n\n.user-print-form .border-gray-800,\n.user-print-form .border-gray-700,\n.user-print-form .border-gray-600 {\n  border-color: #d1d5db !important;\n}\n\n.user-print-form .bg-black,\n.user-print-form .bg-gray-950,\n.user-print-form .bg-gray-950\\/70,\n.user-print-form .bg-gray-900\\/80,\n.user-print-form .bg-gray-900\\/60,\n.user-print-form .bg-gray-900\\/30 {\n  background: #ffffff !important;\n}\n\n.user-print-form .bg-gray-900,\n.user-print-form thead.bg-gray-900 {\n  background: #f3f4f6 !important;\n}\n\n.user-print-form .text-white {\n  color: #111827 !important;\n}\n\n.user-print-form .text-gray-200,\n.user-print-form .text-gray-300,\n.user-print-form .text-gray-400 {\n  color: #374151 !important;\n}\n\n.user-print-form .text-amber-200,\n.user-print-form .text-amber-200\\/90 {\n  color: #374151 !important;\n}\n\n.user-print-form button.bg-amber-200,\n.user-print-form button[class*='bg-[#eda448]'],\n.user-print-form button[style*='background-color'] {\n  background: #2563eb !important;\n  color: #ffffff !important;\n  border: 1px solid #1d4ed8 !important;\n  font-size: 1rem !important;\n}\n\n.user-print-form button.bg-amber-200:hover,\n.user-print-form button[class*='bg-[#eda448]']:hover {\n  background: #1d4ed8 !important;\n}\n\n.user-print-form input[type='radio'],\n.user-print-form input[type='checkbox'] {\n  accent-color: #111827;\n}\n\n/* Hide numbered prefixes only inside form content while generating PDF export */\n.user-print-form.pdf-export-active {\n  padding: 1.5rem !important;\n  margin: 0 !important;\n  overflow: visible !important;\n  max-width: none !important;\n  box-sizing: border-box !important;\n  background: #ffffff !important;\n}\n\n.user-print-form.pdf-export-active .pdf-export-form-title {\n  font-size: 1.5rem !important;\n  font-weight: 600 !important;\n  color: #111827 !important;\n  margin: 0 0 1rem 0 !important;\n  line-height: 1.3 !important;\n}\n\n.user-print-form.pdf-export-active .form-heading-number,\n.user-print-form.pdf-export-active .form-item-number {\n  display: none !important;\n}\n\n.user-print-form.pdf-export-active table {\n  width: 100% !important;\n  table-layout: fixed !important;\n  border-collapse: collapse !important;\n}\n\n.user-print-form.pdf-export-active tr {\n  break-inside: avoid !important;\n  page-break-inside: avoid !important;\n}\n\n.user-print-form.pdf-export-active thead {\n  display: table-header-group !important;\n}\n\n.user-print-form.pdf-export-active label {\n  margin-bottom: 0.625rem !important;\n  display: block !important;\n}\n\n.user-print-form.pdf-export-active .flex.flex-col {\n  gap: 0.25rem !important;\n}\n\n.user-print-form.pdf-export-active input,\n.user-print-form.pdf-export-active textarea,\n.user-print-form.pdf-export-active select {\n  max-width: 100% !important;\n  line-height: 1.5 !important;\n  min-height: 2.25rem !important;\n}\n\n.user-print-form.pdf-export-active input::placeholder,\n.user-print-form.pdf-export-active textarea::placeholder {\n  color: #d1d5db !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #d1d5db !important;\n}\n\n.user-print-form.pdf-export-active input:placeholder-shown,\n.user-print-form.pdf-export-active textarea:placeholder-shown {\n  color: #d1d5db !important;\n  -webkit-text-fill-color: #d1d5db !important;\n}\n\n.user-print-form.pdf-export-blank input::placeholder,\n.user-print-form.pdf-export-blank textarea::placeholder {\n  color: #d1d5db !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #d1d5db !important;\n}\n\n/* Sidebar navigation numbers always stay visible (never part of PDF export) */\naside .sidebar-form-number {\n  display: inline !important;\n}\n\n/* Handwritten signature pad in print-style forms */\n.user-print-form .signature-field-tabs .inline-flex {\n  border-color: #9ca3af !important;\n}\n\n.user-print-form .signature-field-tabs button {\n  background: #ffffff !important;\n  color: #374151 !important;\n}\n\n.user-print-form .signature-field-tabs canvas {\n  background: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
